import React from 'react';
import {
	Box,
	Dialog,
	DialogContent,
	IconButton,
	ThemeProvider,
	Typography,
} from '@mui/material';
import PrimaryButton from '../button/PrimaryButton';
import theme from 'theme/muiTheme';
import { addEventLog } from 'utils/functions/eventLogFunctions';

interface PackingSlipProps {
	cocId: string;
	submissionDate: string;
	contactName: string;
	contactEmail: string;
	isOpen: boolean;
    onClose: () => void;
	maxWidthOverride?: number;
}

const PackingSlip: React.FC<PackingSlipProps> = ({
	cocId,
	submissionDate,
	contactName,
	contactEmail,
	isOpen,
	onClose,
	maxWidthOverride
}) => {

	let dateFormatOptions = new Intl.DateTimeFormat("en-US", {
		month: "short", 
		day: "2-digit", 
		year: "numeric",
	});

	function printPackingSlip () {
		addEventLog(`CoC Packing Slip Printed`, "Lab Request", undefined, undefined, `CoC #: ${cocId}`);
		window.print();
	}

	return (
		
		<ThemeProvider theme={theme}>
			<Dialog open={isOpen} onClose={onClose} maxWidth={maxWidthOverride ? false : 'md'} fullWidth
				sx={maxWidthOverride ? { '& .MuiDialog-paper': { maxWidth: maxWidthOverride + 'px' } } : {}}>

				<div className='no-print'>
					<IconButton
						onClick={onClose}
						sx={{
							position: 'absolute',
							top: 24,
							right: 24,
							p: 0,
							zIndex: 1000,
						}}
						aria-label="close"
					>
						<img
							src="/assets/icons/Close.svg"
							alt="Close"
							style={{
								width: '20px',
								height: '20px',
							}}
						/>
					</IconButton>
				</div>

				<DialogContent id='packing-slip'>

					<div className="no-print">
						<Typography variant="body1" gutterBottom sx={{ textAlign: "center", padding: "8px" }}>
							Thank you for your submission. Your Chain of Custody number is:
						</Typography>
					</div>
					<div className='print-only'>
					<img
							src="/assets/logos/relay.svg"
							alt="LuminUltra Relay"
							style={{ width: '130px', paddingBottom:'15px', margin:'auto'}}
						/>
						<Typography variant="h6" sx={{ textAlign: "center", padding: "8px" }}>
							LuminUltra Chain of Custody #:
						</Typography>
					</div>
					<div className="printable">
					
						<Typography variant="h4" sx={{ textAlign: "center", padding: "8px" }}>
							<b>{cocId}</b>
						</Typography>

						<Typography variant="h6" sx={{ textAlign: "center", padding: "8px" }}>
							Submitted: {submissionDate ? dateFormatOptions.format(new Date(submissionDate)) : ''} <br></br>
							By: {contactName} <br></br>
							{contactEmail}
						</Typography>
					</div>

					<div className="no-print">
						<Typography variant="body1" sx={{ textAlign: "center", padding: "8px" }}>
							<i>Please print this slip and insert it in your sample packaging.</i>
						</Typography>
					</div>

				</DialogContent>
				
				<Box className="no-print" sx={{ textAlign: "center", paddingBottom: "16px" }}>
					<PrimaryButton onClick={printPackingSlip}>Print</PrimaryButton>
				</Box>
				
			</Dialog>
		</ThemeProvider>

	);
};

export default PackingSlip;
